import { useEffect, useRef } from 'react';

const tableScrollSelector = '.ant-table-body, .ant-table-content';

export const useHorizontalTableWheel = <TElement extends HTMLElement = HTMLDivElement>() => {
  const tableWrapRef = useRef<TElement | null>(null);

  useEffect(() => {
    const tableWrap = tableWrapRef.current;
    if (!tableWrap) return;

    const handleNativeTableWheel = (event: WheelEvent) => {
      const scrollContainer = tableWrap.querySelector<HTMLElement>(tableScrollSelector);
      if (!scrollContainer || scrollContainer.scrollWidth <= scrollContainer.clientWidth) return;

      const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!delta) return;

      event.preventDefault();
      event.stopPropagation();
      scrollContainer.scrollLeft += delta;
    };

    tableWrap.addEventListener('wheel', handleNativeTableWheel, { passive: false });
    return () => {
      tableWrap.removeEventListener('wheel', handleNativeTableWheel);
    };
  }, []);

  return tableWrapRef;
};
